import React from 'react'
import GenAIWorkspace from './GenAI/GenAIWorkspace'

const WorkArea = ({ originalTranscript, onInsertToNote, bookingData, userRef, selectedLanguage }) => {
  return (
    <GenAIWorkspace
      originalTranscript={originalTranscript}
      onInsertToNote={onInsertToNote}
      bookingData={bookingData}
      userRef={userRef}
      selectedLanguage={selectedLanguage}
    />
  )
}

export default WorkArea
